import React, { useCallback, useContext, useState } from 'react';
import { Divider } from '@blueprintjs/core';
import { doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';

import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

import { FirebaseContext } from '../firebase/FirebaseContext';
import { Form } from './Form';
import { Remove } from './RemoveDialog';

import './Dashboard.css';
import { logEvent } from 'firebase/analytics';

export const Actions: React.FC<any> = ({
  items,
  setItems,
  selected,
  setSelected,
}) => {
  const { user, db, analytics } = useContext(FirebaseContext);

  const handleAddToWaitlist = useCallback(
    async (item: any) => {
      if (!user) {
        return;
      }

      try {
        const defaultDocRef = doc(
          db,
          'users',
          user.uid,
          'properties',
          'default'
        );

        const unionRes = await updateDoc(defaultDocRef, {
          waitlist: arrayUnion(item),
        });

        logEvent(analytics, 'added_to_waitlist', {
          accountId: user.uid,
        });

        console.log('Res of add', unionRes);
      } catch (e) {
        console.error('Error adding document: ', e);
        logEvent(analytics, 'failed_to_add_to_waitlist', {
          accountId: user.uid,
          error: (e as any).message as string,
        });
      }
    },
    [user, db, analytics]
  );

  const handleRemoveSelected = useCallback(async () => {
    try {
      if (!user) {
        return;
      }

      const selectedItems = items.reduce((acc: any[], item: any) => {
        if (selected[item.id]) acc.push(item);
        return acc;
      }, []);

      const defaultDocRef = doc(db, 'users', user.uid, 'properties', 'default');

      await updateDoc(defaultDocRef, {
        waitlist: arrayRemove(...selectedItems),
      });

      setSelected({});
    } catch (e) {
      console.error('Error removing selected items', e);
    }
  }, [user, selected, setItems, setSelected]);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <section
      style={{
        display: 'flex',
        backgroundColor: 'beige',
        borderRadius: 10,
        padding: '1em',
      }}
    >
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        onClick={() => setIsOpen(true)}
      >
        Add Guest
      </Button>
      <Form
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onAddToWaitlist={handleAddToWaitlist}
      />
      {Object.keys(selected).length ? (
        <div style={{ display: 'flex' }}>
          <Divider />
          <Remove
            count={Object.keys(selected).length}
            onRemoveSelected={handleRemoveSelected}
          />
        </div>
      ) : null}
    </section>
  );
};
